export default defineNuxtPlugin((nuxtApp) => {
  const {
    startSpan,
    startRenderSpan,
    endRequestSpan,
    endRenderSpan,
    getPropagationOutput,
  } = useOpenTelemetryStore()

  // в этот момент начинается рендеринг страницы.
  // начинаем отслеживать время выполнения
  nuxtApp.hook('app:created', () => {
    startRenderSpan()
  })

  // страница создана. заканчиваем запись
  nuxtApp.hook('app:rendered', () => {
    endRenderSpan({ 'http.status_code': 200 })
    endRequestSpan({ 'http.status_code': 200 })
  })

  // страница создана с ошибкой. заканчиваем запись
  nuxtApp.hook('app:error', () => {
    endRenderSpan({ 'http.status_code': 500 })
    endRequestSpan({ 'http.status_code': 500 })
  })

  return {
    provide: {
      openTelemetry: {
        startSpan,
        getPropagationOutput,
      },
    },
  }
})
